module.exports = __webpack_public_path__ + "img/galeria-ornamentais-2.909af259.jpg";